import { VALIDATION_STATES } from '../../../core/const/fields.js';

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    fieldId: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    onChange: {
      type: Function,
      required: true,
    },
    // This prop is where we take the value from when it's single choice
    value: {
      type: [String, Array],
      required: false,
    },
    validationState: {
      type: String,
      default: VALIDATION_STATES.unprocessed,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Number,
      default: 2,
    },
  },

  data() {
    return {
      internalValue: Array.isArray(this.value)
        ? [...this.value] : this.value || this.defaultValue(),
      focusedElement: null,
    };
  },

  computed: {
    inputType() {
      return (this.$props.multiple)
        ? 'checkbox'
        : 'radio';
    },
    isError() {
      return this.validationState === VALIDATION_STATES.error;
    },
  },

  methods: {
    defaultValue() {
      return this.multiple ? [] : '';
    },

    inputId(option) {
      return `${this.fieldId}-${option.value}`;
    },

    inputName(option) {
      if (this.multiple) {
        return `${this.name}-${option.value}`;
      }
      return this.name;
    },

    isChosen(value) {
      if (this.multiple) {
        return !!this.internalValue.find(choice => choice === value);
      }
      return this.internalValue === value;
    },

    isFocused(value) {
      return this.focusedElement === value;
    },

    onChangeHandler(value) {
      this.updateInternalValue(value);

      if (this.multiple) {
        this.onChange([...this.internalValue]);
      } else {
        this.onChange(this.internalValue);
      }
    },

    updateInternalValue(value) {
      if (!this.multiple) {
        this.internalValue = value;
      } else if (this.internalValue.includes(value)) {
        this.internalValue = this.internalValue.filter(internal => internal !== value);
      } else {
        this.internalValue.push(value);
      }
    },
  },
};
